import AssistantChat from "@/components/assistant/AssistantChat";

export default function ParentAssistant() {
  return <AssistantChat testId="parent-assistant"
    subtitle="Fees, school items, payments and receipts, from the school's official records."
    footnote="Amounts and payment status come from DFA Finance. Payments are confirmed only by the payment gateway."
    unavailableText="The DFA Virtual Assistant is not available for your account yet." />;
}
